export default __webpack_public_path__ + "locales/ru/Common.json?hash=c57205966634629ea2d4581c2bb8dcd0";